import wrappedAxios from "../axiosWrapper";

import * as UP from "./urlParsers";
import { BulkX2yResponse, X2yResponse } from "./types";

const createGet = (urlParser: typeof UP.users2Roles.get) => (xId: number) =>
  wrappedAxios<X2yResponse>({
    method: "GET",
    url: urlParser(xId),
  });

const createUpdate =
  (urlParser: typeof UP.users2Roles.update) =>
  (xId: number, payload: X2yResponse) =>
    wrappedAxios<X2yResponse>({
      method: "POST",
      url: urlParser(xId),
      data: payload,
    });

const createBulkGet =
  (urlParser: typeof UP.users2Roles.getBulk) => (xIds: number[]) =>
    wrappedAxios<BulkX2yResponse>({
      method: "POST",
      url: urlParser(),
      data: xIds,
    });

const createBulkUpdate =
  (urlParser: typeof UP.users2Roles.updateBulk) =>
  (xIdd: number[], payload: BulkX2yResponse) =>
    wrappedAxios<BulkX2yResponse>({
      method: "POST",
      url: urlParser(),
      data: payload,
    });

const createRequestCreator = (urlParsers: UP.UrlParsers) => ({
  get: createGet(urlParsers.get),
  update: createUpdate(urlParsers.update),
  getBulk: createBulkGet(urlParsers.getBulk),
  updateBulk: createBulkUpdate(urlParsers.updateBulk),
});

export const users2Roles = createRequestCreator(UP.users2Roles);
export const modules2Roles = createRequestCreator(UP.modules2Roles);
export const templates2Roles = createRequestCreator(UP.templates2Roles);
export const users2NotificationTemplates = createRequestCreator(
  UP.users2NotificationTemplates
);
